@if (form) {
  <form [formGroup]="form" class="main-form" (keydown.enter)="saveCotation()">
    <div class="modal-header">
      <h5 class="modal-title" [innerText]="'ENQUIRIES.AIRLINES_QUOTING.EDIT' | translate"></h5>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        [attr.aria-label]="'GENERAL.CLOSE' | translate"
      ></button>
    </div>
    <div class="modal-body">
      <div class="card section-card mb-3">
        <div
          class="card-header"
          [innerText]="'ENQUIRIES.AIRLINES_QUOTING.AIRLINE' | translate"
        ></div>
        <div class="card-body">
          <div class="row justify-content-center">
            <div class="col-sm-6 col-lg-3">
              <div class="form-group">
                <label
                  [innerText]="'ENQUIRIES.AIRLINES_QUOTING.AIRLINE' | translate"
                ></label>
                <div class="form-control fake-input disabled">
                  <a
                                    [routerLink]="
                                        '/admin/airlines/' +
                                        (currentOffer.airlineId ||
                                            currentOffer.aircraftCompiled.airlineId)
                                    "
                    target="_blank"
                    class="fake-input-text"
                                    [innerHtml]="
                                        currentOffer?.aircraftCompiled
                                            ? currentOffer.aircraftCompiled.airlineTitle
                                            : $safeNavigationMigration(currentOffer.airline?.title)
                                    "
                  ></a>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-3">
              <div class="form-group">
                <label
                  [innerText]="'ENQUIRIES.AIRLINES_QUOTING.COUNTRY' | translate"
                ></label>
                <div class="form-control fake-input disabled">
                  <span
                    class="fake-input-text"
                                    [innerHtml]="
                                        currentOffer?.aircraftCompiled
                                            ? getCountryLabel(
                                                  currentOffer.aircraftCompiled.airlineCountryCode
                                              )
                                            : currentOffer?.airline
                                              ? getCountryLabel(currentOffer.airline.countryCode)
                                              : ''
                                    "
                  ></span>
                </div>
              </div>
            </div>
            @if (enquiry?.type !== EnumEnquiryType.acmi) {
              <div class="col-sm-12 col-lg-6">
                <div class="form-group">
                  <label [innerText]="'GENERAL.AIRCRAFT' | translate"></label>
                  <select
                    class="form-select"
                    id="aircraftCompiledId"
                    formControlName="aircraftCompiledId"
                                [class.is-invalid]="
                                    (form.touched || form.get('aircraftCompiledId').touched) &&
                                    form.get('aircraftCompiledId').status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                    >
                    @for (
                      aircraftCompiled of airlinesAircrafts[
                      currentOffer.airlineId ||
                      currentOffer.aircraftCompiled.airlineId
                      ]
                      ; track
                      aircraftCompiled) {
                      <option
                        [value]="aircraftCompiled.id"
                                    [innerHtml]="
                                        aircraftCompiled.isCargo
                                            ? aircraftCompiled.modelTitle.toUpperCase() +
                                              ' / ' +
                                              aircraftCompiled.weight +
                                              ' kg' +
                                              ' / ' +
                                              aircraftCompiled.volume +
                                              ' m3'
                                            : aircraftCompiled.modelTitle.toUpperCase() +
                                              ' / ' +
                                              aircraftCompiled.seatTotal +
                                              ' PAX'
                                    "
                      ></option>
                    }
                  </select>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched || form.get('aircraftCompiledId').touched) &&
                      form.get('aircraftCompiledId').errors &&
                      form.get('aircraftCompiledId').errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="card section-card mb-3">
        <div class="card-header" [innerText]="'FLIGHTS.LEG' | translate"></div>
        <div class="card-body">
          @if (enquiry && enquiry.itineraries?.length > 1) {
            <div class="form-group">
              <select
                class="form-select"
                id="itineraryId"
                formControlName="itineraryId"
                        [class.is-invalid]="
                            (form.touched || form.get('itineraryId').touched) &&
                            form.get('itineraryId').status === 'INVALID'
                                ? 'danger'
                                : ''
                        "
                (change)="updateItineraryIdOfCotation()"
                >
                <option
                  [ngValue]="null"
                  [innerText]="'GENERAL.PLEASE_SELECT_ONE' | translate"
                ></option>
                @for (itinerary of itinerariesList; track itinerary) {
                  <option
                    [value]="itinerary.value"
                    [innerHtml]="itinerary.title"
                  ></option>
                }
              </select>
              <div class="invalid-tooltip">
                @if (
                  (form.touched || form.get('itineraryId').touched) &&
                  form.get('itineraryId').errors &&
                  form.get('itineraryId').errors['required']
                  ) {
                  <div
                    [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                  ></div>
                }
              </div>
            </div>
          }
          @if (
            form.get('itineraryId').value &&
            legsList[form.get('itineraryId').value].length
            ) {
            <div
              >
              <div class="list-group leg-list-group">
                @for (leg of legsList[form.get('itineraryId').value]; track leg) {
                  <label
                    class="list-group-item leg-list-item"
                            [class.list-group-item-success]="
                                form.get('legsId').value.includes(leg.value)
                            "
                    >
                    <div class="d-flex align-items-start">
                      <input
                        class="form-check-input me-3 mt-1"
                        type="checkbox"
                        [attr.id]="leg.value"
                        [checked]="form.get('legsId').value.includes(leg.value)"
                        (click)="updateLegsId(leg.value)"
                        />
                      <div class="w-100">
                        <div class="fw-semibold">
                          {{ leg.airportDepartTitle || "-" }}
                          ({{ leg.airportDepartIataCode || "-" }} /
                          {{ leg.airportDepartIcaoCode || "-" }})
                          <span class="mx-1">→</span>
                          {{ leg.airportDestinationTitle || "-" }}
                          ({{ leg.airportDestinationIataCode || "-" }} /
                          {{ leg.airportDestinationIcaoCode || "-" }})
                        </div>
                        <div class="small text-muted mt-1">
                          Departure:
                          {{ leg.date ? (leg.date | date: "dd/MM/yyyy") : "-" }}
                          {{ leg.time || "-" }} LT
                        </div>
                      </div>
                    </div>
                  </label>
                }
              </div>
              @if (
                (form.touched || form.get('legsId').touched) &&
                form.get('legsId').errors &&
                form.get('legsId').errors['required']
                ) {
                <div
                  class="text-danger"
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          }
        </div>
      </div>
      <div class="card section-card mb-3">
        <div
          class="card-header"
          [innerText]="'ENQUIRIES.AIRLINES_QUOTING.EDIT' | translate"
        ></div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <div class="row justify-content-center">
              @if (
                ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(
                enquiry.type
                ) ||
                (enquiry.type === EnumEnquiryType.acmi &&
                enquiry.acmiType === EnumAcmiType.adhoc)
                ) {
                <div
                  class="col-sm-6"
                  >
                  <div class="form-group">
                    <label
                      for="nbPax"
                      [innerText]="'FLIGHT_BRIEF.NB_PAX_EXPECTED' | translate"
                    ></label>
                    <input
                      class="form-control"
                      id="nbPax"
                      formControlName="nbPax"
                      min="0"
                      type="number"
                                    [class.is-invalid]="
                                        (form.touched || form.get('nbPax').touched) &&
                                        form.get('nbPax').status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched || form.get('nbPax').touched) &&
                        form.get('nbPax').errors &&
                        form.get('nbPax').errors['required']
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="currency"
                    [innerText]="'GENERAL.CURRENCY' | translate"
                  ></label>
                  <select
                    class="form-select"
                    id="currency"
                    formControlName="currency"
                                    [class.is-invalid]="
                                        (form.touched || form.controls['currency'].touched) &&
                                        form.controls['currency'].status === 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                    (change)="updatedCurrency()"
                    >
                    @for (currency of getCurrencies(); track currency) {
                      <option
                        [value]="currency"
                                        [innerHtml]="
                                            getEnumCurrencySymbol(currency) +
                                            ' (' +
                                            getEnumCurrencyLabel(currency) +
                                            ')'
                                        "
                      ></option>
                    }
                  </select>
                  @if (
                    form.value.currency &&
                    form.value.currency !== getDefaultCurrency() &&
                    todayCurrencyExchangeRate?.currencies?.[form.value.currency]
                    ) {
                    <div
                      class="text-muted"
                      >
                      {{ "GENERAL.TODAY" | translate }}
                      {{ todayCurrencyExchangeRate.date | date: "HH:mm" }}
                      :<br />
                      1 {{ getDefaultCurrency() }} =
                      {{ todayCurrencyExchangeRate.currencies[form.value.currency] }}
                      {{ form.value.currency }}
                    </div>
                  }
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched || form.controls['currency'].touched) &&
                      form.controls['currency'].errors &&
                      form.controls['currency'].errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
              </div>
              @if (enquiry.type === EnumEnquiryType.acmi) {
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiAircraftType"
                      [innerText]="'ENQUIRIES.ACMI.AIRCRAFT_TYPE' | translate"
                    ></label>
                    <input
                      type="text"
                      formControlName="acmiAircraftType"
                      placeholder="B767-300ER // CS-TST"
                      class="form-control"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiAircraftType'].touched) &&
                                            form.controls['acmiAircraftType'].status === 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiAircraftType'].touched) &&
                        form.controls['acmiAircraftType'].errors &&
                        form.controls['acmiAircraftType'].errors['required']
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiAircraftVersion"
                      [innerText]="'ENQUIRIES.ACMI.AIRCRAFT_VERSION' | translate"
                    ></label>
                    <input
                      type="text"
                      formControlName="acmiAircraftVersion"
                      placeholder="309Y"
                      class="form-control"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiAircraftVersion'].touched) &&
                                            form.controls['acmiAircraftVersion'].status ===
                                                'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiAircraftVersion'].touched) &&
                        form.controls['acmiAircraftVersion'].errors &&
                        form.controls['acmiAircraftVersion'].errors[
                        'required'
                        ]
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                  </div>
                </div>
                @if (enquiry.acmiType !== EnumAcmiType.adhoc) {
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        for="acmiDateStart"
                        [innerText]="'ENQUIRIES.ACMI.DATE_START' | translate"
                      ></label>
                      <input
                        type="date"
                        formControlName="acmiDateStart"
                        class="form-control"
                        min="2000-01-01"
                                            [max]="
                                                form.get('acmiDateEnd').value
                                                    ? form.get('acmiDateEnd').value
                                                    : ''
                                            "
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiDateStart'].touched) &&
                                                form.controls['acmiDateStart'].status === 'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          form.controls['acmiDateStart'].touched) &&
                          form.controls['acmiDateStart'].errors &&
                          form.controls['acmiDateStart'].errors[
                          'required'
                          ]
                          ) {
                          <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                          ></div>
                        }
                        @if (
                          (form.touched ||
                          form.controls['acmiDateStart'].touched) &&
                          form.controls['acmiDateStart'].errors &&
                          form.controls['acmiDateStart'].errors[
                          'dateBelowMinimum'
                          ]
                          ) {
                          <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MIN_VALUE'
                                                        | translate
                                                            : {
                                                                  min:
                                                                      form.controls['acmiDateStart']
                                                                          .errors['dateMinimum']
                                                                      | date: 'dd/MM/yyyy'
                                                              }
                                                "
                        ></div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiDateEnd"
                      [innerText]="'ENQUIRIES.ACMI.DATE_END' | translate"
                    ></label>
                    <input
                      type="date"
                      formControlName="acmiDateEnd"
                      class="form-control"
                                            [min]="
                                                form.get('acmiDateStart').value
                                                    ? form.get('acmiDateStart').value
                                                    : '2000-01-01'
                                            "
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiDateEnd'].touched) &&
                                                form.controls['acmiDateEnd'].status === 'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiDateEnd'].touched) &&
                        form.controls['acmiDateEnd'].errors &&
                        form.controls['acmiDateEnd'].errors['required']
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                        ></div>
                      }
                      @if (
                        (form.touched ||
                        form.controls['acmiDateEnd'].touched) &&
                        form.controls['acmiDateEnd'].errors &&
                        form.controls['acmiDateEnd'].errors[
                        'dateBelowMinimum'
                        ]
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MIN_VALUE'
                                                        | translate
                                                            : {
                                                                  min:
                                                                      form.controls['acmiDateEnd']
                                                                          .errors['dateMinimum']
                                                                      | date: 'dd/MM/yyyy'
                                                              }
                                                "
                      ></div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="acmiBhMinimumPerMonth"
                                            [innerText]="
                                                'ENQUIRIES.ACMI.BH_MINIMUM_PER_MONTH' | translate
                                            "
                  ></label>
                  <div [class.input-group]="acmiDatesInMonth()">
                    <input
                      type="number"
                      min="0"
                      formControlName="acmiBhMinimumPerMonth"
                      class="form-control"
                                                [class.is-invalid]="
                                                    (form.touched ||
                                                        form.controls['acmiBhMinimumPerMonth']
                                                            .touched) &&
                                                    form.controls['acmiBhMinimumPerMonth']
                                                        .status === 'INVALID'
                                                        ? 'danger'
                                                        : ''
                                                "
                      />
                    @if (acmiDatesInMonth()) {
                      <span
                        class="input-group-text"
                        >/ {{ "GENERAL.MONTH" | translate }}</span
                        >
                      }
                    </div>
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiBhMinimumPerMonth']
                        .touched) &&
                        form.controls['acmiBhMinimumPerMonth'].errors &&
                        form.controls['acmiBhMinimumPerMonth'].errors[
                        'required'
                        ]
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                        ></div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiMinimumCycleRatio"
                                            [innerText]="
                                                'ENQUIRIES.ACMI.MINIMUM_CYCLE_RATIO' | translate
                                            "
                    ></label>
                    <input
                      type="text"
                      formControlName="acmiMinimumCycleRatio"
                      class="form-control"
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiMinimumCycleRatio']
                                                        .touched) &&
                                                form.controls['acmiMinimumCycleRatio'].status ===
                                                    'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                      placeholder="6:1"
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiMinimumCycleRatio']
                        .touched) &&
                        form.controls['acmiMinimumCycleRatio'].errors &&
                        form.controls['acmiMinimumCycleRatio'].errors[
                        'required'
                        ]
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                        ></div>
                      }
                    </div>
                  </div>
                </div>
              }
              @if (enquiry.acmiType !== EnumAcmiType.adhoc) {
                <div class="col-sm-6 col-lg-4">
                  <div class="form-group">
                    <label
                      for="acmiBase"
                      [innerText]="'ENQUIRIES.ACMI.BASE' | translate"
                    ></label>
                    <input
                      type="text"
                      formControlName="acmiBase"
                      class="form-control"
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiBase'].touched) &&
                                                form.controls['acmiBase'].status === 'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiBase'].touched) &&
                        form.controls['acmiBase'].errors &&
                        form.controls['acmiBase'].errors['required']
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                        ></div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-8">
                  <div class="form-group mb-1">
                    <label
                      for="acmiRouting"
                                            [innerText]="
                                                'ENQUIRIES.ACMI.ROUTING_AIRPORTS' | translate
                                            "
                    ></label>
                    <app-airport-picker
                      inputName="acmiRouting"
                      (setValueToFormControl)="setValueToFormControl($event)"
                      [clearOnSelect]="true"
                    ></app-airport-picker>
                    @if (form.value.acmiRouting.length) {
                      <ul
                        class="list-group"
                        >
                        @for (airportId of form.value.acmiRouting; track airportId) {
                          <li
                            class="list-group-item placeholder-glow d-flex justify-content-between align-items-center gap-2"
                            >
                            @if (!airportsObj[airportId]) {
                              <div
                                class="placeholder w-100"
                              ></div>
                            }
                            @if (airportsObj[airportId]) {
                              <span>
                                IATA:
                                {{ airportsObj[airportId].iataCode }}
                                @if (airportsObj[airportId].icaoCode) {
                                  <span>
                                    | ICAO:
                                    {{ airportsObj[airportId].icaoCode }}
                                  </span>
                                }
                                - {{ airportsObj[airportId].title }}
                              </span>
                            }
                            <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              (click)="removeAcmiRouting(airportId)"
                              >
                              <fa-icon [icon]="faTrash"></fa-icon>
                            </button>
                          </li>
                        }
                      </ul>
                    }
                    <div class="invalid-feedback">
                      @if (
                        (form.touched ||
                        form.controls['acmiRouting'].touched) &&
                        form.controls['acmiRouting'].errors &&
                        form.controls['acmiRouting'].errors['required']
                        ) {
                        <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                        ></div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div class="col-sm-6 col-lg-4">
                <div class="form-group">
                  <label
                    for="acmiNbCrew"
                    [innerText]="'ENQUIRIES.ACMI.NB_CREW' | translate"
                  ></label>
                  <input
                    type="number"
                    min="0"
                    formControlName="acmiNbCrew"
                    class="form-control"
                                        [class.is-invalid]="
                                            (form.touched || form.controls['acmiNbCrew'].touched) &&
                                            form.controls['acmiNbCrew'].status === 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                    />
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched ||
                      form.controls['acmiNbCrew'].touched) &&
                      form.controls['acmiNbCrew'].errors &&
                      form.controls['acmiNbCrew'].errors['required']
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="acmiPerDiemsIncluded"
                                        [innerText]="
                                            'ENQUIRIES.ACMI.PERS_DIEM_INCLUDED' | translate
                                        "
                  ></label>
                  <select
                    class="form-select"
                    id="acmiPerDiemsIncluded"
                    formControlName="acmiPerDiemsIncluded"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiPerDiemsIncluded'].touched) &&
                                            form.controls['acmiPerDiemsIncluded'].status ===
                                                'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                    >
                    <option
                      [ngValue]="true"
                      [innerText]="'GENERAL.YES' | translate"
                    ></option>
                    <option
                      [ngValue]="false"
                      [innerText]="'GENERAL.NO' | translate"
                    ></option>
                  </select>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched ||
                      form.controls['acmiPerDiemsIncluded']
                      .touched) &&
                      form.controls['acmiPerDiemsIncluded'].errors &&
                      form.controls['acmiPerDiemsIncluded'].errors[
                      'required'
                      ]
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
                @if (form.controls['acmiPerDiemsIncluded'].value === false) {
                  <div
                    class="form-group"
                    >
                    <input
                      type="text"
                      formControlName="acmiPerDiems"
                      class="form-control"
                      placeholder="How much crew/member/day"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiPerDiems'].touched) &&
                                            form.controls['acmiPerDiems'].status === 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiPerDiems'].touched) &&
                        form.controls['acmiPerDiems'].errors &&
                        form.controls['acmiPerDiems'].errors['required']
                        ) {
                        <div
                        ></div>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="acmiCrewHotacIncluded"
                    [innerText]="'ENQUIRIES.ACMI.HOTAC_INCLUDED' | translate"
                  ></label>
                  <select
                    class="form-select"
                    id="acmiCrewHotacIncluded"
                    formControlName="acmiCrewHotacIncluded"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiCrewHotacIncluded'].touched) &&
                                            form.controls['acmiCrewHotacIncluded'].status ===
                                                'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                    >
                    <option
                      [ngValue]="true"
                      [innerText]="'GENERAL.YES' | translate"
                    ></option>
                    <option
                      [ngValue]="false"
                      [innerText]="'GENERAL.NO' | translate"
                    ></option>
                  </select>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched ||
                      form.controls['acmiCrewHotacIncluded']
                      .touched) &&
                      form.controls['acmiCrewHotacIncluded'].errors &&
                      form.controls['acmiCrewHotacIncluded'].errors[
                      'required'
                      ]
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        >
                        =
                      </div>
                    }
                  </div>
                </div>
                @if (form.controls['acmiCrewHotacIncluded'].value === false) {
                  <div
                    class="form-group"
                    >
                    <input
                      type="text"
                      formControlName="acmiCrewHotac"
                      class="form-control"
                      placeholder="How much crew/member/day"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiCrewHotac'].touched) &&
                                            form.controls['acmiCrewHotac'].status === 'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                      />
                    <div class="invalid-tooltip">
                      @if (
                        (form.touched ||
                        form.controls['acmiCrewHotac'].touched) &&
                        form.controls['acmiCrewHotac'].errors &&
                        form.controls['acmiCrewHotac'].errors['required']
                        ) {
                        <div
                          [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                        ></div>
                      }
                    </div>
                  </div>
                }
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label
                    for="acmiHasAdditionalInsurance"
                                        [innerText]="
                                            'ENQUIRIES.ACMI.ADDITIONAL_INSURANCE_INCLUDED'
                                                | translate
                                        "
                  ></label>
                  <select
                    class="form-select"
                    id="acmiHasAdditionalInsurance"
                    formControlName="acmiHasAdditionalInsurance"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiHasAdditionalInsurance']
                                                    .touched) &&
                                            form.controls['acmiHasAdditionalInsurance'].status ===
                                                'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                    >
                    <option
                      [ngValue]="true"
                      [innerText]="'GENERAL.YES' | translate"
                    ></option>
                    <option
                      [ngValue]="false"
                      [innerText]="'GENERAL.NO' | translate"
                    ></option>
                  </select>
                  <div class="invalid-tooltip">
                    @if (
                      (form.touched ||
                      form.controls['acmiHasAdditionalInsurance']
                      .touched) &&
                      form.controls['acmiHasAdditionalInsurance']
                      .errors &&
                      form.controls['acmiHasAdditionalInsurance'].errors[
                      'required'
                      ]
                      ) {
                      <div
                        [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                      ></div>
                    }
                  </div>
                </div>
                @if (
                  form.controls['acmiHasAdditionalInsurance'].value === true
                  ) {
                  <div
                    class="form-group"
                    >
                    <input
                      type="text"
                      formControlName="acmiAdditionalInsurance"
                      class="form-control"
                                        [class.is-invalid]="
                                            (form.touched ||
                                                form.controls['acmiAdditionalInsurance'].touched) &&
                                            form.controls['acmiAdditionalInsurance'].status ===
                                                'INVALID'
                                                ? 'danger'
                                                : ''
                                        "
                      placeholder="Précisez"
                      />
                  </div>
                }
              </div>
              @if (enquiry?.acmiType === EnumAcmiType.cargo) {
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiWeightMax"
                      [innerText]="'ENQUIRIES.ACMI.WEIGHT_MAX' | translate"
                    ></label>
                    <div class="input-group">
                      <input
                        type="number"
                        min="0"
                        formControlName="acmiWeightMax"
                        class="form-control"
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiWeightMax'].touched) &&
                                                form.controls['acmiWeightMax'].status === 'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          form.controls['acmiWeightMax'].touched) &&
                          form.controls['acmiWeightMax'].errors &&
                          form.controls['acmiWeightMax'].errors[
                          'required'
                          ]
                          ) {
                          <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                          ></div>
                        }
                      </div>
                      <span class="input-group-text">kg</span>
                    </div>
                  </div>
                </div>
              }
              @if (enquiry?.acmiType === EnumAcmiType.cargo) {
                <div class="col-sm-6">
                  <div class="form-group">
                    <label
                      for="acmiVolumeMax"
                      [innerText]="'ENQUIRIES.ACMI.VOLUME_MAX' | translate"
                    ></label>
                    <div class="input-group">
                      <input
                        type="number"
                        min="0"
                        formControlName="acmiVolumeMax"
                        class="form-control"
                                            [class.is-invalid]="
                                                (form.touched ||
                                                    form.controls['acmiVolumeMax'].touched) &&
                                                form.controls['acmiVolumeMax'].status === 'INVALID'
                                                    ? 'danger'
                                                    : ''
                                            "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          form.controls['acmiVolumeMax'].touched) &&
                          form.controls['acmiVolumeMax'].errors &&
                          form.controls['acmiVolumeMax'].errors[
                          'required'
                          ]
                          ) {
                          <div
                                                [innerText]="
                                                    'FORM_VALIDATIONS.MANDATORY' | translate
                                                "
                          ></div>
                        }
                      </div>
                      <span class="input-group-text">m<sup>3</sup></span>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </li>
        <li class="list-group-item">
          <label
            [innerText]="'ENQUIRIES.AIRLINES_QUOTING.BUYING_PRICE' | translate"
          ></label>
          @for (fieldType of ['InCurrency', '']; track fieldType) {
            <div
              class="form-group mb-2"
              [class.d-none]="fieldType === '' && form.value.currency === defaultCurrency"
              >
              <div class="input-group">
                <input
                  class="form-control"
                  [id]="'buyingPrice' + fieldType"
                  [formControlName]="'buyingPrice' + fieldType"
                  type="number"
                                [class.is-invalid]="
                                    (form.touched || form.get('buyingPrice' + fieldType).touched) &&
                                    form.get('buyingPrice' + fieldType).status == 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                  (keyup)="updatedValue('buyingPrice', fieldType === 'InCurrency')"
                  [placeholder]="'GENERAL.AMOUNT' | translate"
                  />
                <div class="invalid-tooltip">
                  @if (
                    (form.touched ||
                    form.get('buyingPrice' + fieldType).touched) &&
                    form.get('buyingPrice' + fieldType).errors &&
                    form.get('buyingPrice' + fieldType).errors['required']
                    ) {
                    <div
                      [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                    ></div>
                  }
                </div>
                <div
                  class="input-group-text"
                                [innerHtml]="
                                    getEnumCurrencySymbol(
                                        fieldType === 'InCurrency'
                                            ? form.value.currency
                                            : defaultCurrency
                                    )
                                "
                ></div>
              </div>
            </div>
          }
        </li>
        @if (![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)) {
          <li
            class="list-group-item"
            >
            <div class="form-group">
              <label for="cateringByPersonIncluded"
                >Catering par passager inclus dans prix d'achat ?</label
                >
                <select
                  class="form-select"
                  id="cateringByPersonIncluded"
                  formControlName="cateringByPersonIncluded"
                            [class.is-invalid]="
                                (form.touched || form.get('cateringByPersonIncluded').touched) &&
                                form.get('cateringByPersonIncluded').status === 'INVALID'
                                    ? 'danger'
                                    : ''
                            "
                  (change)="updateByPersonIncludedField('cateringByPerson')"
                  >
                  <option
                    [ngValue]="true"
                    [innerText]="'GENERAL.YES' | translate"
                  ></option>
                  <option
                    [ngValue]="false"
                    [innerText]="'GENERAL.NO' | translate"
                  ></option>
                </select>
              </div>
              @if (!form.get('cateringByPersonIncluded').value) {
                <label
                  [innerText]="'ENQUIRY_COTATIONS.CATERING_PER_PASSENGER' | translate"
                ></label>
                @for (fieldType of ['InCurrency', '']; track fieldType) {
                  <div
                    class="form-group mb-2"
                            [class.d-none]="
                                fieldType === '' && form.value.currency === defaultCurrency
                            "
                    >
                    <div class="input-group">
                      <input
                        class="form-control"
                        [id]="'cateringByPerson' + fieldType"
                        [formControlName]="'cateringByPerson' + fieldType"
                        type="number"
                                    [class.is-invalid]="
                                        (form.touched ||
                                            form.get('cateringByPerson' + fieldType).touched) &&
                                        form.get('cateringByPerson' + fieldType).status == 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                                    (keyup)="
                                        updatedValue('cateringByPerson', fieldType === 'InCurrency')
                                    "
                                    [placeholder]="
                                        'Montant en ' + getEnumCurrencySymbol(defaultCurrency)
                                    "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          form.get('cateringByPerson' + fieldType).touched) &&
                          form.get('cateringByPerson' + fieldType).errors &&
                          form.get('cateringByPerson' + fieldType).errors[
                          'isZeroOrBelow'
                          ]
                          ) {
                          <div
                            >
                            Ce champ ne peut être inférieur à zéro.
                          </div>
                        }
                      </div>
                      <div
                        class="input-group-text"
                                    [innerHtml]="
                                        getEnumCurrencySymbol(
                                            fieldType === 'InCurrency'
                                                ? form.value.currency
                                                : defaultCurrency
                                        )
                                    "
                      ></div>
                    </div>
                  </div>
                }
              }
            </li>
          }
          <li class="list-group-item">
            @if (
              ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)
              ) {
              <div
                >
                <div class="form-group">
                  <label for="taxesByPersonIncluded"
                    >Taxes par passager inclus dans prix d'achat ?</label
                    >
                    <select
                      class="form-select"
                      id="taxesByPersonIncluded"
                      formControlName="taxesByPersonIncluded"
                                [class.is-invalid]="
                                    (form.touched || form.get('taxesByPersonIncluded').touched) &&
                                    form.get('taxesByPersonIncluded').status === 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                      (change)="updateByPersonIncludedField('taxesByPerson')"
                      >
                      <option
                        [ngValue]="true"
                        [innerText]="'GENERAL.YES' | translate"
                      ></option>
                      <option
                        [ngValue]="false"
                        [innerText]="'GENERAL.NO' | translate"
                      ></option>
                    </select>
                  </div>
                  @if (!form.value.taxesByPersonIncluded && form.value.legsId.length) {
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          [class.active]="form.value.isTaxesByPersonType === 'leg'"
                          id="taxesByPersonByLeg-tab"
                          data-bs-toggle="tab"
                          href="#taxesByPersonByLeg"
                          role="tab"
                          aria-controls="taxesByPersonByLeg"
                          (click)="updateTaxesByPersonType('leg')"
                                        [innerText]="
                                            'ENQUIRY_COTATIONS.PAX_TAXES_PER_LEG' | translate
                                        "
                        ></a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                                        [class.active]="
                                            form.value.isTaxesByPersonType === 'airport'
                                        "
                          id="taxesByPersonByAirport-tab"
                          data-bs-toggle="tab"
                          href="#taxesByPersonByAirport"
                          role="tab"
                          aria-controls="taxesByPersonByAirport"
                          (click)="updateTaxesByPersonType('airport')"
                                        [innerText]="
                                            'ENQUIRY_COTATIONS.PAX_TAXES_PER_AIRPORT' | translate
                                        "
                        ></a>
                      </li>
                    </ul>
                    <!-- Tab panes -->
                    <div class="tab-content">
                      <div
                        class="tab-pane active"
                        [class.active]="form.value.isTaxesByPersonType === 'leg'"
                        id="taxesByPersonByLeg"
                        role="tabpanel"
                        aria-labelledby="taxesByPersonByLeg-tab"
                        >
                        <div class="card mb-2">
                          <ul
                            class="list-group list-group-flush"
                            formArrayName="taxesByPersonByLeg"
                            >
                            @for (
                              taxByPersonByLeg of form.get(
                              'taxesByPersonByLeg'
                              )['controls']; track
                              taxByPersonByLeg; let i = $index) {
                              <li
                                class="list-group-item"
                                [formGroupName]="i"
                                >
                                @for (fieldType of ['InCurrency', '']; track fieldType) {
                                  <div
                                    class="form-group"
                                                    [class.d-none]="
                                                        fieldType === '' &&
                                                        form.value.currency === defaultCurrency
                                                    "
                                    >
                                    @if (fieldType === 'InCurrency') {
                                      <label
                                                        [attr.for]="
                                                            'taxesByPersonByLeg' + i + fieldType
                                                        "
                                                        [innerHtml]="
                                                            legsObj[
                                                                form.value.taxesByPersonByLeg[i]
                                                                    .legId
                                                            ].title
                                                        "
                                      ></label>
                                    }
                                    <div class="input-group">
                                      <input
                                        class="form-control"
                                                            [id]="
                                                                'taxesByPersonByLeg' +
                                                                i +
                                                                'amount' +
                                                                fieldType
                                                            "
                                        [formControlName]="'amount' + fieldType"
                                        type="number"
                                                            [class.is-invalid]="
                                                                (form.touched ||
                                                                    form
                                                                        .get('taxesByPersonByLeg')
                                                                        .get(i.toString())
                                                                        .get('amount' + fieldType)
                                                                        .touched) &&
                                                                form
                                                                    .get('taxesByPersonByLeg')
                                                                    .get(i.toString())
                                                                    .get('amount' + fieldType)
                                                                    .status === 'INVALID'
                                                                    ? 'danger'
                                                                    : ''
                                                            "
                                                            (keyup)="
                                                                updatedTaxesByPersonByLeg(
                                                                    i,
                                                                    fieldType === 'InCurrency'
                                                                )
                                                            "
                                                            [placeholder]="
                                                                fieldType === ''
                                                                    ? 'Montant en ' +
                                                                      getEnumCurrencySymbol(
                                                                          defaultCurrency
                                                                      )
                                                                    : ''
                                                            "
                                        />
                                      <div class="invalid-tooltip">
                                        @if (
                                          (form.touched ||
                                          form
                                          .get(
                                          'taxesByPersonByLeg'
                                          )
                                          .get(i.toString())
                                          .get(
                                          'amount' + fieldType
                                          ).touched) &&
                                          form
                                          .get('taxesByPersonByLeg')
                                          .get(i.toString())
                                          .get('amount' + fieldType)
                                          .errors &&
                                          form
                                          .get('taxesByPersonByLeg')
                                          .get(i.toString())
                                          .get('amount' + fieldType)
                                          .errors['required']
                                          ) {
                                          <div
                                                                [innerText]="
                                                                    'FORM_VALIDATIONS.MANDATORY'
                                                                        | translate
                                                                "
                                          ></div>
                                        }
                                      </div>
                                      <div
                                        class="input-group-text"
                                                            [innerHtml]="
                                                                getEnumCurrencySymbol(
                                                                    fieldType === 'InCurrency'
                                                                        ? form.value.currency
                                                                        : defaultCurrency
                                                                )
                                                            "
                                      ></div>
                                    </div>
                                  </div>
                                }
                                <div class="form-group">
                                  <label for="nbPax">Nb pax</label>
                                  <input
                                    class="form-control"
                                    id="nbPax"
                                    formControlName="nbPax"
                                    min="0"
                                    type="number"
                                    required
                                    (keyup)="updatedTaxesByPersonByLeg(i)"
                                                        [class.is-invalid]="
                                                            (form.touched ||
                                                                form
                                                                    .get('taxesByPersonByLeg')
                                                                    .get(i.toString())
                                                                    .get('nbPax').touched) &&
                                                            form
                                                                .get('taxesByPersonByLeg')
                                                                .get(i.toString())
                                                                .get('nbPax').status === 'INVALID'
                                                                ? 'danger'
                                                                : ''
                                                        "
                                    />
                                  <div class="invalid-tooltip">
                                    @if (
                                      (form.touched ||
                                      form
                                      .get('taxesByPersonByLeg')
                                      .get(i.toString())
                                      .get('nbPax').touched) &&
                                      form
                                      .get('taxesByPersonByLeg')
                                      .get(i.toString())
                                      .get('nbPax').errors &&
                                      form
                                      .get('taxesByPersonByLeg')
                                      .get(i.toString())
                                      .get('nbPax').errors['required']
                                      ) {
                                      <div
                                                            [innerText]="
                                                                'FORM_VALIDATIONS.MANDATORY'
                                                                    | translate
                                                            "
                                      ></div>
                                    }
                                  </div>
                                </div>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                      <div
                        class="tab-pane"
                        [class.active]="form.value.isTaxesByPersonType === 'airport'"
                        id="taxesByPersonByAirport"
                        role="tabpanel"
                        aria-labelledby="taxesByPersonByAirport-tab"
                        >
                        <div class="card mb-2">
                          <ul
                            class="list-group list-group-flush"
                            formArrayName="taxesByPersonByAirport"
                            >
                            @for (
                              taxByPersonByLeg of form.get(
                              'taxesByPersonByAirport'
                              )['controls']; track
                              taxByPersonByLeg; let i = $index) {
                              <li
                                class="list-group-item"
                                [formGroupName]="i"
                                >
                                @for (fieldType of ['InCurrency', '']; track fieldType) {
                                  <div
                                    class="form-group"
                                                    [class.d-none]="
                                                        fieldType === '' &&
                                                        form.value.currency === defaultCurrency
                                                    "
                                    >
                                    @if (fieldType === 'InCurrency') {
                                      <label
                                                        [attr.for]="
                                                            'taxesByPersonByAirport' + i + fieldType
                                                        "
                                                        [innerHtml]="
                                                            form.value.taxesByPersonByAirport[i]
                                                                .airport
                                                        "
                                      ></label>
                                    }
                                    <div class="input-group">
                                      <input
                                        class="form-control"
                                                            [id]="
                                                                'taxesByPersonByAirport' +
                                                                i +
                                                                'amount' +
                                                                fieldType
                                                            "
                                        [formControlName]="'amount' + fieldType"
                                        type="number"
                                                            [class.is-invalid]="
                                                                (form.touched ||
                                                                    form
                                                                        .get(
                                                                            'taxesByPersonByAirport'
                                                                        )
                                                                        .get(i.toString())
                                                                        .get('amount' + fieldType)
                                                                        .touched) &&
                                                                form
                                                                    .get('taxesByPersonByAirport')
                                                                    .get(i.toString())
                                                                    .get('amount' + fieldType)
                                                                    .status === 'INVALID'
                                                                    ? 'danger'
                                                                    : ''
                                                            "
                                                            (keyup)="
                                                                updatedTaxesByPersonByAirport(
                                                                    i,
                                                                    fieldType === 'InCurrency'
                                                                )
                                                            "
                                                            [placeholder]="
                                                                fieldType === ''
                                                                    ? 'Montant en ' +
                                                                      getEnumCurrencySymbol(
                                                                          defaultCurrency
                                                                      )
                                                                    : ''
                                                            "
                                        />
                                      <div class="invalid-tooltip">
                                        @if (
                                          (form.touched ||
                                          form
                                          .get(
                                          'taxesByPersonByAirport'
                                          )
                                          .get(i.toString())
                                          .get(
                                          'amount' + fieldType
                                          ).touched) &&
                                          form
                                          .get(
                                          'taxesByPersonByAirport'
                                          )
                                          .get(i.toString())
                                          .get('amount' + fieldType)
                                          .errors &&
                                          form
                                          .get(
                                          'taxesByPersonByAirport'
                                          )
                                          .get(i.toString())
                                          .get('amount' + fieldType)
                                          .errors['required']
                                          ) {
                                          <div
                                                                [innerText]="
                                                                    'FORM_VALIDATIONS.MANDATORY'
                                                                        | translate
                                                                "
                                          ></div>
                                        }
                                      </div>
                                      <div
                                        class="input-group-text"
                                                            [innerHtml]="
                                                                getEnumCurrencySymbol(
                                                                    fieldType === 'InCurrency'
                                                                        ? form.value.currency
                                                                        : defaultCurrency
                                                                )
                                                            "
                                      ></div>
                                    </div>
                                  </div>
                                }
                                <div class="form-group">
                                  <label for="nbPax">Nb pax</label>
                                  <input
                                    class="form-control"
                                    id="nbPax"
                                    formControlName="nbPax"
                                    min="0"
                                    type="number"
                                    (keyup)="updatedTaxesByPersonByAirport(i)"
                                                        [class.is-invalid]="
                                                            (form.touched ||
                                                                form
                                                                    .get('taxesByPersonByAirport')
                                                                    .get(i.toString())
                                                                    .get('nbPax').touched) &&
                                                            form
                                                                .get('taxesByPersonByAirport')
                                                                .get(i.toString())
                                                                .get('nbPax').status === 'INVALID'
                                                                ? 'danger'
                                                                : ''
                                                        "
                                    />
                                  <div class="invalid-tooltip">
                                    @if (
                                      (form.touched ||
                                      form
                                      .get(
                                      'taxesByPersonByAirport'
                                      )
                                      .get(i.toString())
                                      .get('nbPax').touched) &&
                                      form
                                      .get('taxesByPersonByAirport')
                                      .get(i.toString())
                                      .get('nbPax').errors &&
                                      form
                                      .get('taxesByPersonByAirport')
                                      .get(i.toString())
                                      .get('nbPax').errors['required']
                                      ) {
                                      <div
                                                            [innerText]="
                                                                'FORM_VALIDATIONS.MANDATORY'
                                                                    | translate
                                                            "
                                      ></div>
                                    }
                                  </div>
                                </div>
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  }
                  @for (fieldType of ['InCurrency', '']; track fieldType) {
                    <div
                      class="form-group"
                            [class.d-none]="
                                fieldType === '' && form.value.currency === defaultCurrency
                            "
                      >
                      @if (fieldType === 'InCurrency') {
                        <label
                          [attr.for]="'taxesTotalPax' + fieldType"
                          >Taxes total passagers</label
                          >
                        }
                        <div class="input-group">
                          <input
                            class="form-control"
                            [id]="'taxesTotalPax' + fieldType"
                            [formControlName]="'taxesTotalPax' + fieldType"
                            type="number"
                                    [class.is-invalid]="
                                        (form.touched ||
                                            form.get('taxesTotalPax' + fieldType).touched) &&
                                        form.get('taxesTotalPax' + fieldType).status == 'INVALID'
                                            ? 'danger'
                                            : ''
                                    "
                                    (keyup)="
                                        updatedValue('taxesTotalPax', fieldType === 'InCurrency')
                                    "
                                    [placeholder]="
                                        'Montant en ' + getEnumCurrencySymbol(defaultCurrency)
                                    "
                            readonly
                            />
                          <div class="invalid-tooltip">
                            @if (
                              (form.touched ||
                              form.get('taxesTotalPax' + fieldType).touched) &&
                              form.get('taxesTotalPax' + fieldType).errors &&
                              form.get('taxesTotalPax' + fieldType).errors[
                              'isZeroOrBelow'
                              ]
                              ) {
                              <div
                                >
                                Ce champ ne peut être inférieur à zéro.
                              </div>
                            }
                          </div>
                          <div
                            class="input-group-text"
                                    [innerHtml]="
                                        getEnumCurrencySymbol(
                                            fieldType === 'InCurrency'
                                                ? form.value.currency
                                                : defaultCurrency
                                        )
                                    "
                          ></div>
                        </div>
                      </div>
                    }
                  </div>
                }
              </li>
              <li class="list-group-item">
                <label
                  [innerText]="'ENQUIRIES.AIRLINES_QUOTING.SELLING_PRICE' | translate"
                ></label>
                @for (fieldType of ['InCurrency', '']; track fieldType) {
                  <div
                    class="form-group mb-2"
                    [class.d-none]="fieldType === '' && form.value.currency === defaultCurrency"
                    >
                    <div class="input-group">
                      <input
                        class="form-control"
                        [id]="'sellingPrice' + fieldType"
                        [formControlName]="'sellingPrice' + fieldType"
                        type="number"
                                [class.is-invalid]="
                                    (form.touched ||
                                        form.get('sellingPrice' + fieldType).touched) &&
                                    form.get('sellingPrice' + fieldType).status == 'INVALID'
                                        ? 'danger'
                                        : ''
                                "
                        (keyup)="updatedValue('sellingPrice', fieldType === 'InCurrency')"
                                [placeholder]="
                                    (fieldType === ''
                                        ? 'GENERAL.AMOUNT'
                                        : 'GENERAL.LEAVE_BLANK_IF_UNKNOWN'
                                    ) | translate
                                "
                        />
                      <div class="invalid-tooltip">
                        @if (
                          (form.touched ||
                          form.get('sellingPrice' + fieldType).touched) &&
                          form.get('sellingPrice' + fieldType).errors &&
                          form.get('sellingPrice' + fieldType).errors['required']
                          ) {
                          <div
                            [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                          ></div>
                        }
                      </div>
                      <div
                        class="input-group-text"
                                [innerHtml]="
                                    getEnumCurrencySymbol(
                                        fieldType === 'InCurrency'
                                            ? form.value.currency
                                            : defaultCurrency
                                    )
                                "
                      ></div>
                    </div>
                  </div>
                }
              </li>
            </ul>
          </div>
          <div class="form-group mb-0">
            <label for="notes" [innerText]="'ENQUIRIES.AIRLINES_QUOTING.NOTES' | translate"></label>
            <textarea
              formControlName="notes"
              class="form-control"
              id="notes"
              rows="5"
                [class.is-invalid]="
                    (form.touched || form.get('notes').touched) &&
                    form.get('notes').status === 'INVALID'
                        ? 'danger'
                        : ''
                "
            ></textarea>
            <div class="invalid-tooltip">
              @if (
                (form.touched || form.get('notes').touched) &&
                form.get('notes').errors &&
                form.get('notes').errors['required']
                ) {
                <div
                  [innerText]="'FORM_VALIDATIONS.MANDATORY' | translate"
                ></div>
              }
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            [innerText]="'GENERAL.CANCEL' | translate"
          ></button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="saveCotation()"
            [disabled]="form.disabled || !form.valid"
            [innerText]="'GENERAL.SAVE' | translate"
          ></button>
        </div>
      </form>
    }
